
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/benefit/jangji/[companyname]",
      function () {
        return require("private-next-pages/benefit/jangji/[companyname].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/benefit/jangji/[companyname]"])
      });
    }
  